import * as React from 'react';
import {
	Text,
	TextProps,
	BreakpointConfigType,
	getValueByScreenSize,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';

type ResponsiveAppearance = TokenTextAppearance | BreakpointConfigType<TokenTextAppearance>;
type ResponsiveTextProps = Omit<TextProps, 'appearance'> & { appearance?: ResponsiveAppearance };

export const ResponsiveText = React.memo(({ appearance, ...rest }: ResponsiveTextProps): React.ReactElement => {
	const [screenSize, setScreenSize] = React.useState<number>(typeof window !== 'undefined' ? window.innerWidth : 0);

	React.useEffect(() => {
		const handleResize = () => setScreenSize(window.innerWidth);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const resolvedAppearance = React.useMemo(
		() => (appearance ? getValueByScreenSize<TokenTextAppearance>(screenSize, appearance) : undefined),
		[appearance, screenSize],
	);

	return <Text {...rest} appearance={resolvedAppearance} />;
});
